module.exports = __webpack_public_path__ + "img/pretty-waves.f9899234.jpg";